<template>
  <div id="goTop" class="goTop" v-show="goTopShow" @click="goTop">
    <img src="@/assets/img/icon/top.png" alt=""/>
  </div>
</template>

<script>
export default {
  name: 'goTop',
  data: function() {
    return {
      scrollTop: '',
      goTopShow: false
    }
  },
  watch: {
    scrollTop(val) {
      this.goTopShow = this.scrollTop > 500
    }
  },
  methods: {
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.goTopShow = this.scrollTop > 500
    },
    goTop() {
      let timer = null, _that = this
      cancelAnimationFrame(timer)
      timer = requestAnimationFrame(function fn() {
        if (_that.scrollTop > 0) {
          _that.scrollTop -= 50
          document.body.scrollTop = document.documentElement.scrollTop = _that.scrollTop
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
          _that.goTopShow = false
        }
      })
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
</style>
